<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-curt-card">
    <v-row class="com-pc-card-header" v-show="pcPanelMode">
      <div class="com-pc-card-title">
        {{ text.title }} {{ tmWtrQualList.curt.obsTime }}
      </div>
    </v-row>

    <template v-if="pcPanelMode">
      <v-row>
        <v-col
          v-for="idx in tmWtrQualList.curt.category.length"
          :key="idx"
          class="tm-pc-slider"
          align="center"

        >
          <!-- <p class="tm-pc-slider-category mb-0 text-left">{{ tmWtrQualList.curt.category[idx - 1].title }}</p> -->
          <v-row no-gutters>
            <v-col
              v-for="item in tmWtrQualList.curt.category[idx - 1].master"
              :key="item.label"
              align="center"
            >
              <!-- <div
                class="tm-pc-slider-side-content"
                v-if="item.label !== tmWtrQualList.curt.category[idx - 1].title"
              > -->
              <div
                class="tm-pc-slider-side-content tm-pc-slider-item__name"
              >
                {{ item.label }}
              </div>
              <div class="tm-pc-slider-side-content tm-pc-slider-item__data">
                {{ item.value }}&nbsp;
                <span v-html="item.unit"></span>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </template>

    <template v-if="!pcPanelMode">
      <v-row class="com-pc-card-contents" no-gutters>
        <v-sheet class="tm-pc-slider tm-pc-no-shadow">
          <v-carousel light v-model="carouselIdx" height="140">
            <v-carousel-item
              v-for="(obs, idx) in tmWtrQualList.curt.category"
              :key="obs.name"
            >
              <v-sheet class="tm-pc-no-shadow">
                <v-row class="tm-pc-slider-side">
                  <v-col class="tm-pc-slider-side-title left">
                    <span>{{ prevTitle(idx) }}</span>
                  </v-col>
                  <v-col class="tm-pc-slider-side-title right">
                    <span>{{ nextTitle(idx) }}</span>
                  </v-col>
                </v-row>

                <v-row no-gutters class="tm-pc-slider-contents" align="center">
                  <v-sheet
                    outlined
                    v-for="item in obs.master"
                    :key="item.label"
                    class="tm-pc-slider-side-sub-item tm-pc-slider-content-qual-size"
                  >
                    <div :class="{ 'tm-pc-curt-standard-over': item.ovflg }">
                      <div class="tm-pc-slider-side-content tm-pc-slider-side-sub-item__name">
                        {{ item.label }}
                      </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="tm-pc-slider-side-content tm-pc-slider-side-sub-item__data">
                      {{ item.value }}
                      <span v-html="item.unit"></span>
                    </div>
                  </v-sheet>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-sheet>
      </v-row>
    </template>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]水質 最新観測値カード
 * TmWtrQualCurt.vue
 * @author ILUKE
 */

export default {
  name: "tm-wtr_qual-curt",
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "最新観測値",
        mark: "※",
      },
    };
  },
  props: {
    carousel: { default: 0, type: Number },
  },
  created: function() {
    this.$store.commit("Telemeter/setLatestObsIdx", this.carousel);
  },
  computed: {
    carouselIdx: {
      get() {
        return this.$store.state.Telemeter.latestObsIdx;
      },
      set(val) {
        this.$store.commit("Telemeter/setLatestObsIdx", val);
      },
    },
    /**
     * 水質 取得
     */
    tmWtrQualList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    prevTitle: function() {
      return function(idx) {
        if (idx === 0) {
          idx = this.$store.state.Telemeter.selectedTm.curt.category.length - 1;
        } else {
          idx = idx - 1;
        }
        var prevTitle = this.$store.state.Telemeter.selectedTm.curt.category[
          idx
        ].title;
        return prevTitle;
      };
    },
    nextTitle: function() {
      return function(idx) {
        if (
          idx ===
          this.$store.state.Telemeter.selectedTm.curt.category.length - 1
        ) {
          idx = 0;
        } else {
          idx = idx + 1;
        }
        var nextTitle = this.$store.state.Telemeter.selectedTm.curt.category[
          idx
        ].title;
        return nextTitle;
      };
    },
    /* フレームの拡大・縮小判定用 */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.tm-pc-slider {
  min-width: 200px;
}
</style>
